<template>
  <div v-if="showBell">
    <button
        id="followButton"
        @click="toggleFollow"
        class="flex items-center gap-1 border border-solid border-theme-secondary rounded-[3px] px-2 hover:bg-black hover:text-white transition-colors duration-200 ease-in-out"
        :class="
          spot.userData.follows
            ? ' text-white bg-theme-secondary'
            : 'text-black'"
    >
      {{
        spot.userData.follows ? $t("spotdetail.isFollowing") : $t("spotdetail.follow")
      }}
        <svg
            class="h-[17px] w-[14px]"
            :class="
              spot.userData.follows ? 'fill-white stroke-white' : 'fill-none stroke-black'
            "
            width="14"
            height="15"
            viewBox="0 -1 14 17"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M7 15C5.88981 15 4.97444 14.1301 4.84835 13.0089H1.90469C1.12952 13.0089 0.5 12.3546 0.5 11.5487C0.5 10.7427 1.12952 10.0885 1.90242 10.0885C1.97343 10.0885 2.02941 10.0297 2.02941 9.95528V6.76944C2.02941 4.49905 3.44412 2.52307 5.47059 1.84229V1.59292C5.47059 0.712073 6.15609 0 7 0C7.84391 0 8.52941 0.713496 8.52941 1.59292V1.84229C10.5563 2.52307 11.9706 4.49858 11.9706 6.76944V9.95528C11.9706 10.0283 12.0284 10.0885 12.0976 10.0885C12.8714 10.0885 13.5 10.7423 13.5 11.5487C13.5 12.3551 12.8714 13.0089 12.0958 13.0089H9.15165C9.02556 14.1301 8.11019 15 7 15Z"
          />
        </svg>
    </button>
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{ spot: SpotDetail}>()

const auth = useAuth();

watch(() => props.spot.userData.follows, (value) => {
  props.spot.userData.follows = value;
});

const showBell = computed(() => {
  return auth.authenticated.value;
});

function toggleFollow() {
  let endpoint = 'follow';

  if (props.spot.userData.follows) {
    endpoint = "unfollow";
  }

  useApiAuth().post("spots/" + props.spot.id.toString() + "/" + endpoint)
    .then(function (response) {
      props.spot.userData.follows = !props.spot.userData.follows;
    })
    .catch(function (error) {
      console.log(error);
    });

}
</script>
<style scoped lang="postcss">
#followButton:hover svg {
  @apply fill-white stroke-white transition-colors duration-200 ease-in-out;
}
</style>
